import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { UserScore, UserRawScore, User, SurveyVersion, CharacteristicGroup, SurveyInstance, CharacteristicGroupSubGroup, SecondaryReport } from '../../models';
import { UserDataService, UserScoreDataService, UserRawScoreDataService, CharacteristicGroupDataService, SurveyInstanceDataService, SecondaryReportDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { UserStore, FilterStore } from '../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { PVAUserSelect, PVASelect, PVASelectOption, LoadingIndicatorMini, PVAPage } from '../../components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './UserScores.css';
import { LoadingIndicator } from '../loadingIndicator/LoadingIndicator';

interface BreakdownRawScore {
    value: number;
    scoreTypeID: number;
    scoreTypeName: string;
    weight: number;
    high: boolean;
}
interface BreakdownScore {
    value: number;
    characteristicID: number;
    characteristicName: string;
    rawScores: BreakdownRawScore[];
}
interface Breakdown {
    scores: BreakdownScore[];
    rawScores: RawBreakdownScore[];
    userScores: UserScore[];
    userRawScores: UserRawScore[];
}

interface RawInconsistentBreakdownUserScore {
    questionNumberOne: number;
    questionTextOne: string;
    optionValueOne: number;
    questionNumberTwo: number;
    questionTextTwo: string;
    optionValueTwo: number;
    value: number;
    available: number;
}
interface RawBreakdownUserScore {
    questionNumber: number;
    questionText: string;
    scoreWeightOption: string;
    questionOptionSelected: string;
    optionValue: number;
    scoreWeightOptionValue: number;
    value: number;
    scoreWeight: number;
}
interface RawBreakdownScore {
    value: number;
    scoreTypeID: number;
    scoreTypeName: string;
    totalAnswers: number;
    totalWeights: number;
    breakdown: RawBreakdownUserScore[];
    inconsistent: RawInconsistentBreakdownUserScore[];
}
// interface RawBreakdown {
//     rawScores: RawBreakdownScore[];
// }

interface UserScoreState {
    orgId: number;
    userId: number;
    surveyVersionId: number;
    surveyId: number;
    selectedSecondaryReportID: number | undefined;
    surveyVersion: SurveyVersion | undefined;
    scores: UserScore[];
    tab: string;
    rawscores: UserRawScore[];
    groups: CharacteristicGroup[];
    breakdown: BreakdownScore[];
    rawbreakdown: RawBreakdownScore[];
    surveyInstances: SurveyInstance[];
    secondaryReports: SecondaryReport[];
    selectedSurveyInstance: number;
    loading: boolean;
    open: boolean;
    saving: boolean;
}

interface UserScoreProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class UserScoreView extends React.Component<UserScoreProps, UserScoreState> {
    private userDataService = new UserDataService(this.props.notificationService);
    private userScoreDataService = new UserScoreDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private userRawScoreDataService = new UserRawScoreDataService(this.props.notificationService);
    private surveyInstanceDataService = new SurveyInstanceDataService(this.props.notificationService);
    private secondaryReportTypeDataService = new SecondaryReportDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get userOrganization() {
        return this.props.UserStore!.userInfo.organization;
    }

    constructor(props: UserScoreProps) {
        super(props);

        this.state = {
            orgId: 0,
            userId: 0,
            surveyVersionId: 0,
            surveyId: 0,
            surveyVersion: undefined,
            selectedSecondaryReportID: undefined,
            secondaryReports: [],
            scores: [],
            rawscores: [],
            groups: [],
            tab: 'rawscores',
            breakdown: [],
            rawbreakdown: [],
            surveyInstances: [],
            selectedSurveyInstance: -1,
            loading: false,
            open: false,
            saving: false
        };

        this.save = this.save.bind(this);
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get organizationName() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return `${this.props.FilterStore!.organization!.name}`;
        }
        return '';
    }

    @computed get surveyReportTypeID() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType.id;
        }
        return 0;
    }

    @computed get surveyReportTypeName() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType.name;
        }
        return '';
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    private updateSurveyVersion() {

        if (this.surveyVersion) {
            this.characteristicGroupDataService.getAllBySurveyVersion(this.surveyVersion).then((groups: CharacteristicGroup[]) => {
                this.setState({
                    groups: groups
                });
            });
        }
    }

    public Update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.setState({
                orgId: this.organization.id
            });
            this.updateSurveyVersion();
            this.updateReport();
        }

        if (this.surveyVersion && this.surveyVersion.id !== this.state.surveyVersionId) {
            this.setState({
                surveyVersionId: this.surveyVersion.id
            });
            this.updateSurveyVersion();
            this.updateReport();

            this.secondaryReportTypeDataService.getAllBySurveyVersion(this.surveyVersion).then((reports: SecondaryReport[]) => {
                this.setState({
                    secondaryReports: reports
                });
            });
        }

    }

    public componentDidMount() {
        this.Update();
    }

    componentWillReact() {
        this.Update();
    }

    private setSecondaryReport(e: any) {
        let val = parseInt(e.target.value, 10);
        this.setState({
            selectedSecondaryReportID: val === 0 ? undefined : val
        });
    }

    private updateReport() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            var user = this.users.find((u: User) => {
                return u.id === this.state.userId;
            });
            if (user && this.props.FilterStore) {
                if (this.state.selectedSurveyInstance > -1) {
                    this.setState({
                        loading: true
                    });

                    var promises: Promise<any>[] = [];

                    promises.push(new Promise((resolve, reject) => {
                        if (user && this.surveyVersion) {
                            this.userScoreDataService.getBreakdown(user, this.state.surveyInstances[this.state.selectedSurveyInstance], this.surveyVersion.id).then((result: Breakdown) => {
                                this.setState(
                                    {
                                        breakdown: result.scores,
                                        rawbreakdown: result.rawScores,
                                        rawscores: result.userRawScores,
                                        scores: result.userScores
                                    },
                                    resolve);
                            });
                        } else {
                            reject();
                        }
                    }));

                    Promise.all(promises).then(() => {
                        this.setState({
                            loading: false
                        });
                    });
                } else {
                    this.setState({
                        scores: [],
                        breakdown: [],
                        rawbreakdown: []
                    });

                    this.characteristicGroupDataService.getAllBySurveyVersion(this.props.FilterStore.surveyVersion).then((groups: CharacteristicGroup[]) => {
                        this.setState({
                            groups: groups
                        });
                    });
                }
            } else {
                if (this.surveyVersion) {
                    this.userRawScoreDataService.getStructure(this.surveyVersion).then((userRawScores: UserRawScore[]) => {
                        this.setState({
                            rawscores: userRawScores
                        });
                    });
                    this.characteristicGroupDataService.getAllBySurveyVersion(this.surveyVersion).then((groups: CharacteristicGroup[]) => {
                        this.setState({
                            groups: groups
                        });
                        if (this.surveyVersion) {
                            this.userScoreDataService.getStructure(this.surveyVersion).then((userScores: UserScore[]) => {
                                this.setState({
                                    scores: userScores
                                });
                            });
                        }
                    });
                }
            }
        }
    }

    public userChange(e: any) {
        var userId: number = Number(e.target.value);
        console.log('User change', userId);
        this.setState({
            userId: userId
        });

        if (!this.survey) {
            return;
        }

        this.surveyInstanceDataService.list(this.survey.id, userId).then((results: SurveyInstance[]) => {
            console.log(results);

            if (results.length > 0) {
                this.setState(
                    {
                        surveyInstances: results.filter((si: SurveyInstance) => {
                            return si.completedDate;
                        }),
                        selectedSurveyInstance: 0
                    },
                    () => {
                        this.updateReport();
                    });

            } else {
                this.setState({
                    surveyInstances: [],
                    selectedSurveyInstance: -1
                });
            }
        });

    }

    private sortRawScore(a: UserRawScore, b: UserRawScore) {
        if (a.scoreType.sort > b.scoreType.sort) {
            return 1;
        } else if (a.scoreType.sort < b.scoreType.sort) {
            return -1;
        }
        return 0;
    }

    private saveScores() {
        var user = this.users.find((u: User) => {
            return u.id === this.state.userId;
        });
        if (user && this.surveyVersion && this.state.selectedSurveyInstance > -1) {
            this.setState({
                saving: true
            });
            var scoresToSend: UserScore[] = [];
            this.state.scores.map((us) => {
                scoresToSend.push({
                    characteristicID: us.characteristicID,
                    score: us.score,
                    id: us.id,
                    userId: us.userId,
                    overriden: us.overriden
                });
            });
            console.log(scoresToSend);
            this.userScoreDataService.save(user, this.state.surveyInstances[this.state.selectedSurveyInstance], scoresToSend).then(() => {
                this.setState({
                    saving: false
                });
            });
        }
    }

    private saveRawScores() {
        var user = this.users.find((u: User) => {
            return u.id === this.state.userId;
        });
        if (user && this.surveyVersion) {
            this.setState({
                saving: true
            });
            this.userRawScoreDataService.save(user, this.surveyVersion, this.state.rawscores).then(() => {
                this.setState({
                    saving: false
                });
            });
        }
    }

    private exportScores() {
        var user = this.users.find((u: User) => {
            return u.id === this.state.userId;
        });
        if (user && this.surveyVersion && this.state.selectedSurveyInstance > -1) {
            this.userScoreDataService.export(user, this.state.surveyInstances[this.state.selectedSurveyInstance], 'UserScores');
        }
    }

    private exportRawScores() {
        var user = this.users.find((u: User) => {
            return u.id === this.state.userId;
        });
        if (user && this.surveyVersion) {
            this.userRawScoreDataService.export(user, this.surveyVersion, 'UserRawScores');
        }
    }

    private selectedSurveyInviteID() {
        if (this.state.selectedSurveyInstance > -1) {
            return this.state.surveyInstances[this.state.selectedSurveyInstance].id;
        }
        return -1;
    }

    private setSurveyInvite(id: number) {
        var si = this.state.surveyInstances.findIndex((x: SurveyInstance) => {
            return x.id === id;
        });

        this.setState({
            selectedSurveyInstance: si
        },            this.updateReport);
    }

    private clear() {
        if (!this.surveyVersion) {
            return;
        }

        this.setState({
            loading: true,
            open: false
        });
        this.userScoreDataService.clear(this.state.surveyInstances[this.state.selectedSurveyInstance], this.surveyVersion.id).then(() => {
            this.props.notificationService.addInfo('Cleared scores');
            this.updateReport();
        });
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    <li className="options-header">Actions</li>

                    <li className="options-entry" onClick={(e) => this.clear()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-list-alt" /> <span> Clear Scores</span>
                        </div>
                        <div className="options-entry-desc">
                            Clears out all cached scores for the selected survey instance and version
                        </div>
                    </li>
                </ul>
            </div>);
    }

    public render() {
        if (this.state.saving) {
            return <LoadingIndicator />;
        }
        var offset = 0;
        var offset2 = 0;

        var availableAreasTF: string[] = [];
        var areasAddedTF: any = {};
        var availableAreasLikert: string[] = [];
        var areasAddedLikert: any = {};
        var availableAreasMeta: string[] = [];
        var areasAddedMeta: any = {};

        if (this.state.rawscores) {
            this.state.rawscores.filter((s: UserRawScore) => {
                return s.scoreType.scoringType === 'trueFalse' || s.scoreType.scoringType === 'trueFalseInconsistent' || s.scoreType.scoringType === 'trueFalseConsistent';
            }).map((x: UserRawScore) => {
                var area = x.scoreType.area || '';
                var areaID = area.toLowerCase();
                if (!areasAddedTF[areaID]) {
                    areasAddedTF[areaID] = true;
                    availableAreasTF.push(area);
                }
            });

            this.state.rawscores.filter((s: UserRawScore) => {
                return s.scoreType.scoringType === 'likert' || s.scoreType.scoringType === 'likertInconsistent' || s.scoreType.scoringType === 'likertConsistent';
            }).map((x: UserRawScore) => {
                var area = x.scoreType.area || '';
                var areaID = area.toLowerCase();
                if (!areasAddedLikert[areaID]) {
                    areasAddedLikert[areaID] = true;
                    availableAreasLikert.push(area);
                }
            });

            this.state.rawscores.filter((s: UserRawScore) => {
                return s.scoreType.scoringType === 'maxScore';
            }).map((x: UserRawScore) => {
                const area = x.scoreType.area || '';
                const areaID = area.toLowerCase();
                if (!areasAddedMeta[areaID]) {
                    areasAddedMeta[areaID] = true;
                    availableAreasMeta.push(area);
                }
            });
            
            const comparer = (area1: string, area2: string) => {
                if (area1 > area2) {
                    return 1;
                } else if (area1 < area2) {
                    return -1;
                }
                return 0;
            };

            availableAreasTF.sort(comparer);
            availableAreasLikert.sort(comparer);
            availableAreasMeta.sort(comparer)
        }

        var surveyInvites: PVASelectOption[] = [];
        this.state.surveyInstances.map((si: SurveyInstance) => {
            var dt = new Date(si.completedDate);
            surveyInvites.push({
                id: si.id,
                label: (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear()
            });
        });

        var groups = this.state.groups.filter((g: CharacteristicGroup) => {
            return g.surveyReportTypeID === this.surveyReportTypeID;
        });

        return (
            <PVAPage>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}

                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            User Scores <span className="light">for </span>
                            <PVAUserSelect options={this.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)}/>
                            <PVASelect options={surveyInvites} selected={this.selectedSurveyInviteID()} onChange={(e: any) => this.setSurveyInvite(parseInt(e.target.value, 10))} />
                            {this.state.loading && <LoadingIndicatorMini />}
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        {this.ActionsButton()}
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    <div className="content-container">
                        <div>
                            <i>'{this.survey && this.survey.name}'</i>
                        </div>
                        <label>Viewing for Report</label>
                        <select className="form-control" value={this.state.selectedSecondaryReportID ? this.state.selectedSecondaryReportID : 0} onChange={(e) => this.setSecondaryReport(e)}>
                            <option value={0}>Individual Report</option>
                            {this.state.secondaryReports.map((sr: SecondaryReport) => {
                                return <option key={`sr-${sr.id}`} value={sr.id}>{sr.name}</option>;
                            })}
                        </select>
                        <br />
                        <div>
                            <ul className="nav nav-tabs" role="tablist">
                                <li role="presentation" className={this.state.tab === 'rawscores' ? 'active' : ''}>
                                    <a onClick={(e) => this.setState({tab: 'rawscores'})} aria-controls="profile" role="tab" data-toggle="tab">Raw Scores</a>
                                </li>
                                <li role="presentation" className={this.state.tab === 'scores' ? 'active' : ''}>
                                    <a onClick={(e) => this.setState({tab: 'scores'})} aria-controls="scores" role="tab" data-toggle="tab">User Scores</a>
                                </li>
                                <li role="presentation" className={this.state.tab === 'rawbreakdown' ? 'active' : ''}>
                                    <a onClick={(e) => this.setState({tab: 'rawbreakdown'})} aria-controls="messages" role="tab" data-toggle="tab">Raw Breakdown</a>
                                </li>
                                <li role="presentation" className={this.state.tab === 'breakdown' ? 'active' : ''}>
                                    <a onClick={(e) => this.setState({tab: 'breakdown'})} aria-controls="messages" role="tab" data-toggle="tab">Breakdown</a>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div role="tabpanel" className={'tab-pane' + (this.state.tab === 'scores' ? 'active' : '')}>
                                    <div>
                                        {
                                            groups.filter((g: CharacteristicGroup) => (!this.state.selectedSecondaryReportID && !g.secondaryReportID) || (this.state.selectedSecondaryReportID && g.secondaryReportID === this.state.selectedSecondaryReportID))
                                                .sort((g1: CharacteristicGroup, g2: CharacteristicGroup) => {
                                                    if (g1.sort > g2.sort) {
                                                        return 1;
                                                    } else if (g1.sort < g2.sort) {
                                                        return -1;
                                                    }
                                                    return 0;
                                                }).map((g: CharacteristicGroup, index: number) => {
                                                var numberOffset = offset;
                                                return <div key={`group-${index}`}>
                                                    <h3>{g.name}</h3>
                                                    <table className="table">
                                                        <tbody>
                                                        <tr>
                                                            <td className="table-scores-1">Characteristic</td>
                                                            <td className="table-scores-2">Score</td>
                                                        </tr>
                                                        {
                                                            this.state.scores && this.state.scores.filter((x) => {
                                                                for (var i = 0; i < g.characteristicGroupCharacteristics.length; i++) {
                                                                    var c = g.characteristicGroupCharacteristics[i].characteristic; // .id;
                                                                    if (c && x.characteristic && c.id === x.characteristic.id) {
                                                                        return true;
                                                                    }
                                                                }
                                                                return false;
                                                            }).sort((a: UserScore, b: UserScore) => {
                                                                if (!a.characteristic || !b.characteristic) {
                                                                    return 0;
                                                                }
                                                                if (a.characteristic.sort > b.characteristic.sort) {
                                                                    return 1;
                                                                } else if (a.characteristic.sort < b.characteristic.sort) {
                                                                    return -1;
                                                                }
                                                                return 0;
                                                            }).map((score: UserScore, charIndex: number) => {
                                                                offset++;

                                                                return <tr key={`score-${index}-${charIndex}`}>
                                                                    <td className="table-scores-1">
                                                                        <NavLink to={`/characteristic/${score.characteristic && score.characteristic.id}`}>
                                                                            {numberOffset + charIndex + 1}. {score.characteristic && score.characteristic.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td className="table-scores-2">
                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => {score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                                    </td>
                                                                </tr>;
                                                            })
                                                        }
                                                        {
                                                            g.characteristicGroupSubGroups.map((cgsg: CharacteristicGroupSubGroup) => {
                                                                return <React.Fragment key={`cgsg-${cgsg.id}`}>
                                                                    {cgsg.characteristicGroupSubGroupCharacteristics.map((cgsgc, cgsgcInd) => {
                                                                        return <React.Fragment key={`cgsg-${cgsg.id}-c-${cgsgc.id}`}>
                                                                            {this.state.scores && this.state.scores.filter((x) => {
                                                                                var c = cgsgc.characteristicID; // .id;
                                                                                if (x.characteristic && c === x.characteristic.id) {
                                                                                    return true;
                                                                                }
                                                                                return false;
                                                                            }).sort((a: UserScore, b: UserScore) => {
                                                                                if (!a.characteristic || !b.characteristic) {
                                                                                    return 0;
                                                                                }
                                                                                if (a.characteristic.sort > b.characteristic.sort) {
                                                                                    return 1;
                                                                                } else if (a.characteristic.sort < b.characteristic.sort) {
                                                                                    return -1;
                                                                                }
                                                                                return 0;
                                                                            }).map((score: UserScore, charIndex: number) => {
                                                                                numberOffset++;
                                                                                offset++;

                                                                                return <tr key={`cgsg-${cgsg.id}-score-${index}-${charIndex}`}>
                                                                                    <td className="table-scores-1">
                                                                                        <NavLink to={`/characteristic/${score.characteristic && score.characteristic.id}`}>
                                                                                            {numberOffset + charIndex}. {score.characteristic && score.characteristic.name}
                                                                                        </NavLink>
                                                                                    </td>
                                                                                    <td className="table-scores-2">
                                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => {score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                                                    </td>
                                                                                </tr>;
                                                                            })}
                                                                        </React.Fragment>;
                                                                    })}
                                                                </React.Fragment>;
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>;
                                            })
                                        }
                                        <div>
                                            <h3>Ungrouped</h3>

                                            <table className="table">
                                                <tbody>
                                                {
                                                    this.state.scores && this.state.scores.filter((x) => {
                                                        for (var g = 0; g < groups.length; g++) {
                                                            for (var i = 0; i < groups[g].characteristicGroupCharacteristics.length; i++) {
                                                                if (groups[g].characteristicGroupCharacteristics[i].characteristicID === (x.characteristic ? x.characteristic.id : 0)) {
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        return true;
                                                    }).sort((a: UserScore, b: UserScore) => {
                                                        if (!a.characteristic || !b.characteristic) {
                                                            return 0;
                                                        }
                                                        if (a.characteristic.sort > b.characteristic.sort) {
                                                            return 1;
                                                        } else if (a.characteristic.sort < b.characteristic.sort) {
                                                            return -1;
                                                        }
                                                        return 0;
                                                    }).map((score: UserScore, charIndex: number) => {
                                                        offset++;

                                                        return <tr key={`ungrouped-score-${charIndex}`}>
                                                            <td className="table-scores-1">
                                                                <NavLink to={`/characteristic/${score.characteristic && score.characteristic.id}`}>
                                                                    {score.characteristic && score.characteristic.name}
                                                                </NavLink>
                                                            </td>
                                                            <td className="table-scores-2">
                                                                <input type="number" className="form-control" value={score.score} onChange={(e) => {score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                            </td>
                                                        </tr>;
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">
                                            <a className="btn btn-primary" onClick={(e) => this.saveScores()}>Save</a>
                                        </div>
                                        <div className="col-xs-6 text-right">
                                            <a className="btn btn-primary" onClick={(e) => this.exportScores()}>Export .csv</a>
                                        </div>
                                    </div>
                                </div>
                                <div role="tabpanel" className={'tab-pane' + (this.state.tab === 'rawscores' ? 'active' : '')}>
                                    <div className="row">
                                        <div className="col-sm-6 true-false-scores">
                                            <h3>True/False Raw Scores</h3>
                                            <table className="table table-scores">
                                                {
                                                    availableAreasTF.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-tf-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={2}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'trueFalse' || s.scoreType.scoringType === 'trueFalseInconsistent' || s.scoreType.scoringType === 'trueFalseConsistent') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                return <tr key={`urs-tf-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => { score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div>
                                        <div className="col-sm-6 likert-scores">
                                            <h3>Likert Raw Scores</h3>
                                            <table className="table">
                                                {
                                                    availableAreasLikert.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-likert-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={2}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'likert' || s.scoreType.scoringType === 'likertInconsistent' || s.scoreType.scoringType === 'likertConsistent') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                return <tr key={`urs-liker-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => { score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div>
                                        {availableAreasMeta.length > 0 && <div className="col-sm-6 other-scores">
                                            <h3>Meta Scores</h3>
                                            <table className="table">
                                                {
                                                    availableAreasMeta.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-other-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={2}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'maxScore') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                return <tr key={`urs-other-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => { score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} disabled={true} />
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div>}
                                    </div>
                                    {false && <div className="col-sm-6 other-scores">
                                        <h3>Meta Scores</h3>
                                        <table className="table">
                                            {
                                                availableAreasMeta.map((x: string, areaIndex: number) => {
                                                    return <tbody key={`area-other-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={2}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'maxScore') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                return <tr key={`urs-other-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" value={score.score} onChange={(e) => { score.score = parseInt(e.target.value, 10); this.forceUpdate(); }} disabled={true} />
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                })
                                            }
                                        </table>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <a className="btn btn-primary" onClick={(e) => this.saveRawScores()}>Save</a>
                                    </div>
                                </div>
                                <div role="tabpanel" className={'tab-pane' + (this.state.tab === 'breakdown' ? 'active' : '')}>
                                    <h5>Using Report Type: {this.surveyReportTypeName}</h5>
                                    {
                                        groups.filter((g: CharacteristicGroup) => (!this.state.selectedSecondaryReportID && !g.secondaryReportID) || (this.state.selectedSecondaryReportID && g.secondaryReportID === this.state.selectedSecondaryReportID))
                                            .sort((g1: CharacteristicGroup, g2: CharacteristicGroup) => {
                                                if (g1.sort > g2.sort) {
                                                    return 1;
                                                } else if (g1.sort < g2.sort) {
                                                    return -1;
                                                }
                                                return 0;
                                            }).map((g: CharacteristicGroup, index: number) => {
                                            var numberOffset = offset2;
                                            return <div key={`group-${index}`}>
                                                <h3>{g.name}</h3>

                                                <table className="table breakdown-table">
                                                    <tbody>
                                                    {
                                                        this.state.scores && this.state.scores.filter((x) => {
                                                            for (var i = 0; i < g.characteristicGroupCharacteristics.length; i++) {
                                                                var c = g.characteristicGroupCharacteristics[i].characteristic; // .id;
                                                                if (c && c.id === (x.characteristic ? x.characteristic.id : 0)) {
                                                                    return true;
                                                                }
                                                            }
                                                            return false;
                                                        }).sort((a: UserScore, b: UserScore) => {
                                                            if (!a.characteristic || !b.characteristic) {
                                                                return 0;
                                                            }
                                                            if (a.characteristic.sort > b.characteristic.sort) {
                                                                return 1;
                                                            } else if (a.characteristic.sort < b.characteristic.sort) {
                                                                return -1;
                                                            }
                                                            return 0;
                                                        }).map((userScore: UserScore, charIndex: number) => {
                                                            offset2++;

                                                            if (!this.state.breakdown) {
                                                                return <tr key={`userScore-${index}-${charIndex}`} />;
                                                            }

                                                            var score = this.state.breakdown.find((s: BreakdownScore) => {
                                                                return s.characteristicID === (userScore.characteristic ? userScore.characteristic.id : 0);
                                                            });

                                                            if (!score) {
                                                                return <tr key={`userScore-${index}-${charIndex}`} />;
                                                            }

                                                            return <tr key={`breakdown-score-${index}-${charIndex}`}>
                                                                <td className="table-breakdown-1"><b>{numberOffset + charIndex + 1}. {score.characteristicName}</b></td>
                                                                <td className="table-breakdown-2">{score.value.toFixed(2)}</td>
                                                                <td className="table-breakdown-3">
                                                                    <table className="table">
                                                                        <tbody>
                                                                        <tr>
                                                                            <td className="table-score-breakdown-1">Raw Score</td>
                                                                            <td className="table-score-breakdown-2">Score</td>
                                                                            <td className="table-score-breakdown-3">Weight</td>
                                                                            <td className="table-score-breakdown-4">Result</td>
                                                                        </tr>
                                                                        {
                                                                            score.rawScores.map((rawScore, rawScoreIndex: number) => {
                                                                                if (!score) {
                                                                                    return <div key={userScore.id} />;
                                                                                }

                                                                                const tooltip = <Tooltip>
                                                                                    {rawScore.high && <span>{rawScore.value} * {(rawScore.weight * 100.0).toFixed(2)}% </span>}
                                                                                    {!rawScore.high && <span>(100 - {rawScore.value}) * {(rawScore.weight * 100.0).toFixed(2)}% </span>}
                                                                                </Tooltip>;

                                                                                return <tr key={`breakdown-score-${index}-${charIndex}-${rawScoreIndex}`}>
                                                                                    <td>{rawScore.scoreTypeName}: </td>
                                                                                    <td>{rawScore.value}</td>
                                                                                    <td>
                                                                                        {rawScore.high && <span>H </span>}
                                                                                        {!rawScore.high && <span>L </span>}
                                                                                        {(rawScore.weight * 100.0).toFixed(2)}%
                                                                                    </td>
                                                                                    <td>
                                                                                        {rawScore.high && <OverlayTrigger animation={false} delay={0} placement="top" overlay={tooltip}>
                                                                                            <span>= {(rawScore.value * rawScore.weight).toFixed(2)}</span>
                                                                                        </OverlayTrigger>}
                                                                                        {!rawScore.high && <OverlayTrigger animation={false} delay={0} placement="top" overlay={tooltip}>
                                                                                            <span>= {((100 - rawScore.value) * rawScore.weight).toFixed(2)}</span>
                                                                                        </OverlayTrigger>}
                                                                                    </td>
                                                                                </tr>;
                                                                            })
                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>;
                                                        })
                                                    }
                                                    </tbody>
                                                </table>

                                                <table className="table breakdown-table">
                                                    <tbody>
                                                    {
                                                        g.characteristicGroupSubGroups.map(cgsg => {
                                                            return <React.Fragment key={`cgsg-${cgsg.id}`}>
                                                                {cgsg.characteristicGroupSubGroupCharacteristics.map(cgsgc => {
                                                                    return <React.Fragment key={`cgsg-${cgsg.id}-cgsgc-${cgsgc.id}`}>

                                                                        {
                                                                            this.state.scores && this.state.scores.filter((x) => {
                                                                                var c = cgsgc.characteristicID; // .id;
                                                                                if (c && c === (x.characteristic ? x.characteristic.id : 0)) {
                                                                                    return true;
                                                                                }
                                                                                return false;
                                                                            }).sort((a: UserScore, b: UserScore) => {
                                                                                if (!a.characteristic || !b.characteristic) {
                                                                                    return 0;
                                                                                }
                                                                                if (a.characteristic.sort > b.characteristic.sort) {
                                                                                    return 1;
                                                                                } else if (a.characteristic.sort < b.characteristic.sort) {
                                                                                    return -1;
                                                                                }
                                                                                return 0;
                                                                            }).map((userScore: UserScore, charIndex: number) => {
                                                                                offset2++;

                                                                                if (!this.state.breakdown) {
                                                                                    return <tr key={`userScore-${index}-${charIndex}`} />;
                                                                                }

                                                                                var score = this.state.breakdown.find((s: BreakdownScore) => {
                                                                                    return s.characteristicID === (userScore.characteristic ? userScore.characteristic.id : 0);
                                                                                });

                                                                                if (!score) {
                                                                                    return <tr key={`userScore-${index}-${charIndex}`} />;
                                                                                }

                                                                                return <tr key={`breakdown-score-${index}-${charIndex}`}>
                                                                                    <td className="table-breakdown-1"><b>{offset2 + charIndex}. {score.characteristicName}</b></td>
                                                                                    <td className="table-breakdown-2">{score.value.toFixed(2)}</td>
                                                                                    <td className="table-breakdown-3">
                                                                                        <table className="table">
                                                                                            <tbody>
                                                                                            <tr>
                                                                                                <td className="table-score-breakdown-1">Raw Score</td>
                                                                                                <td className="table-score-breakdown-2">Score</td>
                                                                                                <td className="table-score-breakdown-3">Weight</td>
                                                                                                <td className="table-score-breakdown-4">Result</td>
                                                                                            </tr>
                                                                                            {
                                                                                                score.rawScores.map((rawScore, rawScoreIndex: number) => {
                                                                                                    if (!score) {
                                                                                                        return <div key={userScore.id} />;
                                                                                                    }

                                                                                                    const tooltip = <Tooltip>
                                                                                                        {rawScore.high && <span>{rawScore.value} * {(rawScore.weight * 100.0).toFixed(2)}% </span>}
                                                                                                        {!rawScore.high && <span>(100 - {rawScore.value}) * {(rawScore.weight * 100.0).toFixed(2)}% </span>}
                                                                                                    </Tooltip>;

                                                                                                    return <tr key={`breakdown-score-${index}-${charIndex}-${rawScoreIndex}`}>
                                                                                                        <td>{rawScore.scoreTypeName}: </td>
                                                                                                        <td>{rawScore.value}</td>
                                                                                                        <td>
                                                                                                            {rawScore.high && <span>H </span>}
                                                                                                            {!rawScore.high && <span>L </span>}
                                                                                                            {(rawScore.weight * 100.0).toFixed(2)}%
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {rawScore.high && <OverlayTrigger animation={false} delay={0} placement="top" overlay={tooltip}>
                                                                                                                <span>= {(rawScore.value * rawScore.weight).toFixed(2)}</span>
                                                                                                            </OverlayTrigger>}
                                                                                                            {!rawScore.high && <OverlayTrigger animation={false} delay={0} placement="top" overlay={tooltip}>
                                                                                                                <span>= {((100 - rawScore.value) * rawScore.weight).toFixed(2)}</span>
                                                                                                            </OverlayTrigger>}
                                                                                                        </td>
                                                                                                    </tr>;
                                                                                                })
                                                                                            }
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>;
                                                                            })
                                                                        }

                                                                    </React.Fragment>;
                                                                })}
                                                            </React.Fragment>;
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>;
                                        })
                                    }

                                    <div>
                                        <span>
                                            H: High = Raw Score * Weight = Score
                                        </span>
                                    </div>
                                    <div>
                                        <span>
                                            L: Low = (100 - Raw Score) * Weight = Score
                                        </span>
                                    </div>
                                </div>
                                <div role="tabpanel" className={'tab-pane' + (this.state.tab === 'rawbreakdown' ? 'active' : '')}>
                                    <div>
                                        <div className="true-false-scores">
                                            <h3>True/False Raw Scores</h3>
                                            <table className="table table-scores">
                                                {
                                                    availableAreasTF.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-tf-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={3}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'trueFalse' || s.scoreType.scoringType === 'trueFalseInconsistent' || s.scoreType.scoringType === 'trueFalseConsistent') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                var rawBreakdown: RawBreakdownScore | undefined = undefined;
                                                                if (this.state.rawbreakdown) {
                                                                    rawBreakdown = this.state.rawbreakdown.find((rbs: RawBreakdownScore) => {
                                                                        return rbs.scoreTypeID === score.scoreTypeID;
                                                                    });
                                                                }

                                                                return <tr key={`urs-tf-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        {rawBreakdown && <span>{rawBreakdown.value}</span>}
                                                                    </td>
                                                                    <td>
                                                                        {rawBreakdown && rawBreakdown.breakdown && rawBreakdown.breakdown.length > 0 && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Q#</td>
                                                                                <td>Question</td>
                                                                                <td>SW Option</td>
                                                                                <td>SW Option Value</td>
                                                                                <td>SW Value</td>
                                                                                <td>User Selected</td>
                                                                                <td>User Selected Value</td>
                                                                                <td>Result</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {rawBreakdown.breakdown.map((rbus: RawBreakdownUserScore, rbusIndex: number) => {
                                                                                return <tr key={`rbus-${rbusIndex}`}>
                                                                                    <td>
                                                                                        {rbus.questionNumber}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionText}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeightOption}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeightOptionValue}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeight}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionOptionSelected}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValue}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.value}
                                                                                    </td>
                                                                                </tr>;
                                                                            })}
                                                                            </tbody>
                                                                        </table>}
                                                                        {rawBreakdown && rawBreakdown.inconsistent && rawBreakdown.inconsistent.length > 0 && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Q1#</td>
                                                                                <td>Question</td>
                                                                                <td>Option</td>
                                                                                <td>Q2#</td>
                                                                                <td>Question</td>
                                                                                <td>Option</td>
                                                                                <td>Result</td>
                                                                                <td>Available</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {rawBreakdown.inconsistent.map((rbus: RawInconsistentBreakdownUserScore, rbusIndex: number) => {
                                                                                return <tr key={`rbus-incon-${rbusIndex}`}>
                                                                                    <td>
                                                                                        {rbus.questionNumberOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionTextOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValueOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionNumberTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionTextTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValueTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.value}
                                                                                    </td>
                                                                                    <td>
                                                                                        <span style={{color: '#ccc'}}>{rbus.available}</span>
                                                                                    </td>
                                                                                </tr>;
                                                                            })}
                                                                            </tbody>
                                                                        </table>}
                                                                        {rawBreakdown && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Total Score</td>
                                                                                <td>Total Available</td>
                                                                                <td>Fraction</td>
                                                                                <td>Result</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    {rawBreakdown.totalWeights}
                                                                                </td>
                                                                                <td>
                                                                                    {rawBreakdown.totalAnswers}
                                                                                </td>
                                                                                <td>
                                                                                    {(rawBreakdown.totalWeights / rawBreakdown.totalAnswers).toFixed(2)}
                                                                                </td>
                                                                                <td colSpan={5}>
                                                                                    {Math.round((rawBreakdown.totalWeights / rawBreakdown.totalAnswers) * 100.0)}
                                                                                </td>
                                                                            </tr>
                                                                            </tbody>
                                                                        </table>}
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div>
                                        <div className="likert-scores">
                                            <h3>Likert Raw Scores</h3>
                                            <table className="table">
                                                {
                                                    availableAreasLikert.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-likert-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={2}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'likert' || s.scoreType.scoringType === 'likertInconsistent' || s.scoreType.scoringType === 'likertConsistent') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                var rawBreakdown: RawBreakdownScore | undefined = undefined;
                                                                if (this.state.rawbreakdown) {
                                                                    rawBreakdown = this.state.rawbreakdown.find((rbs: RawBreakdownScore) => {
                                                                        return rbs.scoreTypeID === score.scoreTypeID;
                                                                    });
                                                                }

                                                                return <tr key={`urs-tf-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        {rawBreakdown && <span>{rawBreakdown.value}</span>}
                                                                    </td>
                                                                    <td>
                                                                        {rawBreakdown && rawBreakdown.breakdown && rawBreakdown.breakdown.length > 0 && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Q#</td>
                                                                                <td>Question</td>
                                                                                <td>SW Option</td>
                                                                                <td>SW Option Value</td>
                                                                                <td>SW Value</td>
                                                                                <td>User Selected</td>
                                                                                <td>User Selected Value</td>
                                                                                <td>Result</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {rawBreakdown.breakdown.map((rbus: RawBreakdownUserScore, rbusIndex: number) => {
                                                                                return <tr key={`rbus-${rbusIndex}`}>
                                                                                    <td>
                                                                                        {rbus.questionNumber}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionText}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeightOption}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeightOptionValue}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.scoreWeight}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionOptionSelected}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValue}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.value}
                                                                                    </td>
                                                                                </tr>;
                                                                            })}
                                                                            </tbody>
                                                                        </table>}
                                                                        {rawBreakdown && rawBreakdown.inconsistent && rawBreakdown.inconsistent.length > 0 && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Q1#</td>
                                                                                <td>Question</td>
                                                                                <td>Option</td>
                                                                                <td>Q2#</td>
                                                                                <td>Question</td>
                                                                                <td>Option</td>
                                                                                <td>Result</td>
                                                                                <td>Available</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {rawBreakdown.inconsistent.map((rbus: RawInconsistentBreakdownUserScore, rbusIndex: number) => {
                                                                                return <tr key={`rbus-incon-${rbusIndex}`}>
                                                                                    <td>
                                                                                        {rbus.questionNumberOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionTextOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValueOne}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionNumberTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.questionTextTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.optionValueTwo}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rbus.value}
                                                                                    </td>
                                                                                    <td>
                                                                                        <span style={{color: '#ccc'}}>{rbus.available}</span>
                                                                                    </td>
                                                                                </tr>;
                                                                            })}
                                                                            </tbody>
                                                                        </table>}
                                                                        {rawBreakdown && <table className="table table-striped">
                                                                            <thead>
                                                                            <tr>
                                                                                <td>Total Score</td>
                                                                                <td>Total Available</td>
                                                                                <td>Fraction</td>
                                                                                <td>Result</td>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    {rawBreakdown.totalWeights}
                                                                                </td>
                                                                                <td>
                                                                                    {rawBreakdown.totalAnswers}
                                                                                </td>
                                                                                <td>
                                                                                    {(rawBreakdown.totalWeights / rawBreakdown.totalAnswers).toFixed(2)}
                                                                                </td>
                                                                                <td colSpan={5}>
                                                                                    {Math.round((rawBreakdown.totalWeights / rawBreakdown.totalAnswers) * 100.0)}
                                                                                </td>
                                                                            </tr>
                                                                            </tbody>
                                                                        </table>}
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div>
                                        { false && <div className="other-scores">
                                            <h3>Meta Scores</h3>
                                            <table className="table other-scores">
                                                {
                                                    availableAreasMeta.map((x: string, areaIndex: number) => {
                                                        return <tbody key={`area-others-${areaIndex}`}>
                                                        <tr>
                                                            <td col-span={3}>
                                                                <b>{x}</b>
                                                            </td>
                                                        </tr>
                                                        {
                                                            this.state.rawscores && this.state.rawscores.filter((s: UserRawScore) => {
                                                                var area = s.scoreType.area || '';
                                                                return (s.scoreType.scoringType === 'maxScore') && area.toLowerCase() === x.toLowerCase();
                                                            }).sort(this.sortRawScore).map((score: UserRawScore, ursInd: number) => {
                                                                var rawBreakdown: RawBreakdownScore | undefined = undefined;
                                                                if (this.state.rawbreakdown) {
                                                                    rawBreakdown = this.state.rawbreakdown.find((rbs: RawBreakdownScore) => {
                                                                        return rbs.scoreTypeID === score.scoreTypeID;
                                                                    });
                                                                }

                                                                return <tr key={`urs-others-${areaIndex}-${ursInd}`}>
                                                                    <td>
                                                                        <NavLink to={`/scoreType/${score.scoreType.id}`}>
                                                                            {score.scoreType.name}
                                                                        </NavLink>
                                                                    </td>
                                                                    <td>
                                                                        {<span>{123}</span>}
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>;
                                                    })
                                                }
                                            </table>
                                        </div> }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.userDataService.create(values).then((success) => {
            this.props.history.push('/user');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/userscore/UserScoreView.tsx